jQuery(document).ready(function () {

	/**
	 * functions
	 */
	var $jsNavigation = jQuery('.js-navigation');
	var $jsSearchPanel = jQuery('.js-search-panel');
	function openNavigation() {
		jQuery('.js-hamburger').addClass('js-hamburger-active');
		$jsNavigation.addClass('js-navigation-active');
	}

	function closeNavigation() {
		jQuery('.js-hamburger').removeClass('js-hamburger-active');
		$jsNavigation.removeClass('js-navigation-active');
		$jsNavigation.find('.js-sub-menu-icon').removeClass('jam-chevron-up');
		$jsNavigation.find('.sub-menu').addClass('hidden');
		$jsNavigation.find('.menu-item-has-children').removeClass('bg-whisper');
	}

	var $searchAllIcon = jQuery('.js-search-all-icon');
	function closeSearchBox() {
		$searchAllIcon.children().addClass('jam-search');
		$jsSearchPanel.removeClass('js-search-panel-active');
		jQuery('.js-search-all').val('');
		jQuery('.js-search-panel-container').empty();
		$jsSearchPanel.children().append('<h3 class="font-sans text-tuna font-normal mb-1">Ange ditt sökord</h3>');
	}

	function openSearchBox() {
		jQuery(window).trigger('resize');
		$searchAllIcon.children().removeClass('jam-search');
		jQuery('.js-search-all').focus();
		$jsSearchPanel.addClass('js-search-panel-active');
		jQuery('.js-sticky-menu').removeClass('js-sticky-menu-active');
		jQuery('.js-sticky-welcome').removeClass('js-sticky-welcome-active');
		jQuery('.js-sticky-button').find('.jam').addClass('jam-envelope');
	}
	$searchAllIcon.on('click', function(e) {
		if($searchAllIcon.children('.jam-search').length === 0) {
			closeSearchBox();
		}
	});

	/**
	 * hide navigation on scroll function
	 */
	function hasScrolled() {

		if ($jsSearchPanel.hasClass("js-search-panel-active") || $jsNavigation.hasClass('js-navigation-active')) {

			jQuery('.js-navigation-header').removeAttr("style");
			return;

		} else {

			var st = jQuery(window).scrollTop();

			// Make sure they scroll more than delta
			if (Math.abs(lastScrollTop - st) <= delta)
				return;
			// If they scrolled down and are past the navbar, add minus top of navigation height.
			// This is necessary so you never see what is "behind" the navbar.
			if (st > lastScrollTop && st > navbarHeight) {
				// Scroll Down
				jQuery('.js-navigation-header').css('top', -navbarHeight);
			} else {
				// Scroll Up
				if (st + jQuery(window).height() < jQuery(document).height()) {
					jQuery('.js-navigation-header').removeAttr("style")
				}
			}
			lastScrollTop = st;
		};

	}


	// search all (input)
	jQuery(".js-search-all").on('click', function () {
		openSearchBox();
	});

	// when clicking inside any of the named classes don't do anything
	$jsSearchPanel.parent().on('click', function (e) {
		e.stopImmediatePropagation();
		e.stopPropagation();
	});

	// outside of the named classes do this
	jQuery(document).on('click', function () {
		closeSearchBox();
	})

	/**
	 * hamburger
	 */

	jQuery('.js-hamburger').on('click', function () {
		if (jQuery(this).hasClass('js-hamburger-active')) {
			closeNavigation();
		} else {
			openNavigation();
		}
	});

	/**
	 * hide navigation on scroll
	 */

	var didScroll;
	var lastScrollTop = 0;
	var delta = 5;
	var navbarHeight = jQuery('.js-navigation-header').outerHeight();

	window.addEventListener('scroll', function (event) {
		didScroll = true;
	}, {passive:true});

	setInterval(function () {

		if (didScroll) {
			hasScrolled();
			didScroll = false;
		}

	}, 250);

/**
 * navigation menu responsive
 */

// hide sub menu when mobile
jQuery(window).on('lessThan-lg', function () {
	var $menuItemHasChildren = $jsNavigation.find('.menu-item-has-children');
	$menuItemHasChildren.children('.sub-menu').addClass('hidden');

	$menuItemHasChildren.find("a[href$='#']").on('click', function (e) {
		var $this = $(this);
		e.preventDefault();
		$this.find('.js-sub-menu-icon').toggleClass('jam-chevron-up');
		$this.parents('li').toggleClass('bg-whisper').find('.sub-menu').toggleClass('hidden');
	});

	$jsNavigation.find('.js-sub-menu-icon').on('click', function (e) {
		var $this = $(this);
		e.stopPropagation();
		e.preventDefault();
		$this.toggleClass('jam-chevron-up');
		$this.parents('li').toggleClass('bg-whisper').find('.sub-menu').toggleClass('hidden');

	});

});

// remove hide class as it triggers on hover when dekstop
jQuery(window).on('greaterEqualTo-lg', function () {

	var $menuItemHasChildren = jQuery('.menu-item-has-children');
	var $linkChildren = $menuItemHasChildren.find("a[href$='#']");
	$linkChildren.unbind();
	$linkChildren.find('.js-sub-menu-icon').removeClass('jam-chevron-up');
	$linkChildren.parents('li').removeClass('bg-whisper').find('.sub-menu').removeClass('hidden');

	$menuItemHasChildren.removeClass('bg-whisper').children('.sub-menu').removeClass('hidden');
	$jsNavigation.removeClass('js-navigation-active');
	jQuery('.js-hamburger').removeClass('js-hamburger-active');
	$jsNavigation.find('.js-sub-menu-icon').removeClass('jam-chevron-up');
	jQuery(".js-sub-menu-icon").unbind("click");
});

});
